module.exports = __webpack_public_path__ + "static/img/join_4.6bc4423.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/join/join_4.jpg
// module id = g8xh
// module chunks = 0